/**
 * @module types/settings/colorSetting
 * @description 词云颜色配置（存储字段名 `colorSetting`）
 */

export interface IColorSettingSwatch {
  hexa: string;
  alpha: string;
}

export interface IColorSettingValue {
  type: string;
  colorName?: string;
  colors: IColorSettingSwatch[];
}

const PURE_COLOR_DEFAULT_SWATCH: IColorSettingSwatch = Object.freeze({
  hexa: '#5086F3',
  alpha: '100',
}) as IColorSettingSwatch;

const PURE_COLOR_DEFAULT_COLORS: IColorSettingSwatch[] = Object.freeze([
  PURE_COLOR_DEFAULT_SWATCH,
]) as IColorSettingSwatch[];

/**
 * colorSetting 缺省：纯色主题 #5086F3
 *
 * @stable 须与 STRUCTURED_SETTING_DEFAULTS.colorSetting 为同一引用语义
 */
export const COLOR_SETTING_DEFAULT: IColorSettingValue = Object.freeze({
  type: 'pureColor',
  colors: PURE_COLOR_DEFAULT_COLORS,
}) as IColorSettingValue;

/** 写入 draft / 重置用的可变副本（避免冻结对象进 draft） */
export function cloneColorSettingDefault(): IColorSettingValue {
  return {
    type: COLOR_SETTING_DEFAULT.type,
    colors: COLOR_SETTING_DEFAULT.colors.map(({ hexa, alpha }) => ({
      hexa,
      alpha,
    })),
  };
}
